import React from 'react';
import { Box } from '@mui/material';
import { tokens } from '../../../theme/tokens';

/** The tutorial's type: labels, numbered circles, titles and lead text. */

export const Label: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box component='span' sx={{ fontSize: 12.5, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: tokens.ink3 }}>
    {children}
  </Box>
);

/** A numbered circle for the "1, 2, 3" lists. */
export const Num: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    component='span'
    aria-hidden
    sx={{
      width: 30,
      height: 30,
      flexShrink: 0,
      borderRadius: '50%',
      bgcolor: tokens.accentSoft,
      color: tokens.accent,
      fontWeight: 700,
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    {children}
  </Box>
);

export const StepTitle: React.FC<{ id?: string; children: React.ReactNode }> = ({ id, children }) => (
  <Box component='h2' id={id} sx={{ m: 0, fontFamily: tokens.display, fontSize: { xs: 26, md: 30 }, fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
    {children}
  </Box>
);

export const Lead: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box component='p' sx={{ m: 0, fontSize: { xs: 15, md: 16 }, color: tokens.ink2, maxWidth: 720, lineHeight: 1.5 }}>
    {children}
  </Box>
);
